export const DEFAULT_ITEM_PER_PAGE = 5;
export const COUNTDOWN_TIME_REFRESH = 5;